import React, { useContext, useEffect, useRef, useState } from "react";
import { useTheme } from "emotion-theming";
import { useHistory } from "react-router-dom";
import { Text } from "@nykaa/payment-ui/src/Text";
import { CircularLoader } from "@nykaa/payment-ui/src/CircularLoader";

import { get } from "logics/src/utils/helpers";
import { SavedPaymentView } from "layouts/SavedPayment";
import { NewPaymentDetails } from "layouts/CheckoutPayment/mobile/NewPaymentDetails";
import { MorePaymentMethod } from "layouts/CheckoutPayment/mobile/AllSavedPaymentMethod/MorePaymentMethod";
import { ShippingAddress } from "layouts/CheckoutPayment/mobile/ShippingAddress";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { default as WalletMultiModal } from "layouts/Payment/WalletMultimodal";
import { getStringFromId } from "helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { PAYMENT_SCREENS } from "constants/paymentScreens";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { checkIsAddressIdDelCookiePresent } from "layouts/Payment/common/dependencies/dependencyhelpers";
import { getStorageData } from "helpers/utils/storage";
import { PAYTM_AUTOPAY } from "constants/cookies";
import { MainLoaderLoayoutWrapper } from "layouts/CheckoutPayment/assets/style";
import { SavedPaymentWrapper } from "layouts/SavedPayment/assets/style";
import PaymentView from "layouts/Payment/Loadable";
import { ErrorBoundary } from "components/ErrorBoundary";
import { RetryWalletTile } from "components/RetryWalletTile";
import PaymentOffers from "layouts/PaymentOffers/Loadable";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { getPlatform } from "../../../../helpers";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { checkIsExperimentEligible } from "helpers/utils/isExperimentEligible";
import { useEddConfig } from "hooks/useEdd";

import { DeliveryToast } from "../DeliveryToast";
import {
  BuyerAssuranceWrapper,
  SectionTitleWrapper,
  SectionWrapper,
} from "./assets/styles";
import { BuyerAssurance } from "../AllPaymentMethod/components/BuyerAssurance";
import { ShippingAddressContent } from "../ShippingAddress/assets/style";
import DeliveryEstimate from "../EstimateDelivery";
import { AddressNotMatchedMessageCard } from "../AddressNotMatchedMessageCard";


interface ISavePaymentView {
  setIsWalletChecked: any;
  timerCallback: any;
  setUpiDetails: any;
  isGPayIntentAvailable: boolean;
  loading: boolean;
  showAllPaymentMethods: boolean;
  setPaymentScreen: any;
  isDeliveryEstimateToastVisible: boolean;
  setIsDeliveryEstimateToastVisible: React.Dispatch<React.SetStateAction<boolean>>;
  areSavedPaymentMethodsDisplayed: boolean;
  isSavedPaymentVisible: boolean;
  isNewPaymentMethodVisible: boolean;
  isWalletDisplayed: boolean;
  newPaymentMethod: any;
  priceDetailConfig: any;
  proceedToPayVisible: boolean;
  isFailureUrl: boolean;
}

export const SavePaymentView = ({
  setIsWalletChecked,
  timerCallback,
  setUpiDetails,
  isGPayIntentAvailable,
  loading,
  showAllPaymentMethods,
  setPaymentScreen,
  isDeliveryEstimateToastVisible,
  setIsDeliveryEstimateToastVisible,
  areSavedPaymentMethodsDisplayed,
  isSavedPaymentVisible,
  isNewPaymentMethodVisible,
  isWalletDisplayed,
  newPaymentMethod,
  priceDetailConfig,
  proceedToPayVisible,
  isFailureUrl,
}: ISavePaymentView) => {
  const history = useHistory();
  const platform = getPlatform();
  const theme: Theme = useTheme();
  const paymentContext = useContext(PaymentContext);
  const { applicationData } = useContext(ApplicationContext);
  const { PaymentOfferRevamp, EddPosition2 } = useContext(ExperimentAndSwitchContext);

  const walletConfig = paymentContext?.walletConfig;
  const giftCardConfig = paymentContext?.giftCardInfoConfig;
  const orderAmount = paymentContext?.orderAmount;
  const cartInfo = get(paymentContext, "cartInfo");
  const offersData: any = get(paymentContext, "offersData");
  const grandTotal = get(cartInfo, "grandTotal");
  const walletBalance = get(walletConfig, "walletBalance");
  const isFullPaymentByGiftCard = get(giftCardConfig, "isFullPaymentByGiftCard");
  const flowConfig = get(paymentContext, "flowConfig");
  const { isApp } = applicationData;
  const setLoading = get(paymentContext, "setLoading");
  const isPaymentInfoLoading = paymentContext?.isPaymentInfoLoading;
  const visibleOfferBottomSheet = paymentContext?.visibleOfferBottomSheet;
  const setVisibleOfferBottomSheet = paymentContext?.setVisibleOfferBottomSheet;
  const paymentScreen = get(paymentContext, "paymentScreen");
  const showRetryWalletTile = paymentContext?.showRetryWalletTile;
  const isRetryWalletExpEnabled = paymentContext?.isRetryWalletExpEnabled;
  const handleRetryWalletClick = paymentContext?.handleRetryWalletClick;

  const query = new URLSearchParams(history.location.search);
  const autoCreateOrder = query.get("autoCreateOrder");
  const payTmAutoPay = getStorageData(PAYTM_AUTOPAY, false) || "false";
  const autoPayTmCreateOrder = autoCreateOrder === "true" && payTmAutoPay === "true";

  const SavedPaymentOption = getStringFromId(
    VERNACULAR_STRING_IDS.SAVED_PAYMENT_OPTIONS,
    VERNACULAR_DEFAULT_MESSAGES.SAVED_PAYMENT_OPTIONS
  );
  const defaultAddressMessage = getStringFromId(
    VERNACULAR_STRING_IDS.DEFAULT_ADDRESS_MESSAGE,
    VERNACULAR_DEFAULT_MESSAGES.DEFAULT_ADDRESS_MESSAGE
  );
  const toastDeliveryMessage = getStringFromId(
    VERNACULAR_STRING_IDS.TOAST_DELIVERY_MESSAGE,
    VERNACULAR_DEFAULT_MESSAGES.TOAST_DELIVERY_MESSAGE
  );
  const NykaaWalletTitle = getStringFromId(
    VERNACULAR_STRING_IDS.NYKAA_WALLET_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.NYKAA_WALLET_TITLE
  );
  const OrderInformation = getStringFromId(
    VERNACULAR_STRING_IDS.ORDER_INFORMATION,
    VERNACULAR_DEFAULT_MESSAGES.ORDER_INFORMATION
  );
  const unableToFetchWalletText = getStringFromId(
    VERNACULAR_STRING_IDS.UNABLE_TO_FECTH_WALLLET,
    VERNACULAR_DEFAULT_MESSAGES.UNABLE_TO_FECTH_WALLLET
  );
  const retryButtonText = getStringFromId(
    VERNACULAR_STRING_IDS.RETRY,
    VERNACULAR_DEFAULT_MESSAGES.RETRY
  );

  const [isScrollToEddElement, setIsScrollToEddElement] = useState(false);
  const [isCheckButtonClickedOnToast, setIsCheckButtonClickedOnToast] = useState(false);
  const [isEddContainerExpanded, setIsEddContainerExpanded] = useState(false);
  const deliveryElementRef = useRef(null);
  const isAddressIdDelCookiePresent = checkIsAddressIdDelCookiePresent();

  let expandedEstimateDeliveryToggle = checkIsExperimentEligible(
    "expandedEstimateDelivery.savedPage"
  );

  useEffect(() => {
    setIsEddContainerExpanded(!!expandedEstimateDeliveryToggle);
  }, [expandedEstimateDeliveryToggle]);

  const eddConfig = useEddConfig({
    isExpanded: isCheckButtonClickedOnToast || isEddContainerExpanded,
    deliveryElementRef: deliveryElementRef,
    isApp,
  });

  if (isScrollToEddElement) {
    setTimeout(() => {
      (deliveryElementRef?.current as any)?.scrollIntoView({ behavior: "smooth" });
      if (!loading) {
        setIsScrollToEddElement(false);
      }
    }, 100);
  }

  setTimeout(() => {
    setIsDeliveryEstimateToastVisible(false);
  }, 5000);

  return (
    <div className="layout vertical mt20 mb10">
      {flowConfig?.address && (
        <ShippingAddressContent>
          <AddressNotMatchedMessageCard
            isAddressIdDelCookiePresent={isAddressIdDelCookiePresent}
            defaultAddressMessage={defaultAddressMessage}
            leadingIcon={getIcons(platform, ICONS_NAMES.EDD_INFO_ICON)}
          />
          <ShippingAddress addressBarDataTestId="txt_address_bar" />
        </ShippingAddressContent>
      )}

      {isPaymentInfoLoading && !isFailureUrl ? (
        <MainLoaderLoayoutWrapper>
          <CircularLoader />
        </MainLoaderLoayoutWrapper>
      ) : (
        <>
          {PaymentOfferRevamp.experimentEnabled && (
            <PaymentOffers
              isVisible={flowConfig?.offers && paymentScreen === PAYMENT_SCREENS.SAVED}
              offersData={offersData}
              platform={platform}
              visibleOfferBottomSheet={visibleOfferBottomSheet}
              setVisibleOfferBottomSheet={setVisibleOfferBottomSheet}
              savedPaymentPage={true}
              isAutoScroll={true}
              showCarouselDots={true}
              setLoading={setLoading}
              isApp={isApp}
            />
          )}
          {flowConfig?.wallet && isWalletDisplayed && !!walletBalance && (
            <SectionWrapper className="layout vertical prl20 payment-view">
              <h3 className="font-size-16 lh-24 font-semibold">{NykaaWalletTitle}</h3>
              <ErrorBoundary message="Failed to load wallet section" theme={theme}>
                <div
                  className={`${isFullPaymentByGiftCard &&
                    walletBalance >= grandTotal &&
                    "disabled-layer"}`}
                >
                  <WalletMultiModal
                    walletConfig={walletConfig}
                    giftCardConfig={giftCardConfig}
                    orderAmount={orderAmount}
                    setIsWalletChecked={setIsWalletChecked}
                  />
                </div>
              </ErrorBoundary>
            </SectionWrapper>
          )}
          {showRetryWalletTile && isRetryWalletExpEnabled && (
            <SectionWrapper>
              <RetryWalletTile
                nykaaWalletTitle={NykaaWalletTitle}
                handleRetryWalletClick={handleRetryWalletClick}
                unableToFetchWalletText={unableToFetchWalletText}
                retryButtonText={retryButtonText}
                theme={theme}
              />
            </SectionWrapper>
          )}
          {isSavedPaymentVisible && (
            <SavedPaymentView
              timerCallback={timerCallback}
              setUpiDetails={setUpiDetails}
              isGPayIntentAvailable={isGPayIntentAvailable}
              autoPayTmCreateOrder={autoPayTmCreateOrder}
            />
          )}
          {isNewPaymentMethodVisible && (
            <SavedPaymentWrapper
              className={`layout vertical payment-view visible-layer ${isFullPaymentByGiftCard &&
                "disabled-layer"}`}
              data-testid="lb_paymentMethods"
            >
              {!isSavedPaymentVisible && (
                <SectionTitleWrapper>
                  <Text
                    text={SavedPaymentOption}
                    font={theme.typography.sectionTitle}
                    color={theme.primaryText}
                    theme={theme}
                    data-testid="txt_saved_payment_option"
                  />
                </SectionTitleWrapper>
              )}
              <PaymentView
                orderAmount={orderAmount}
                giftCardConfig={giftCardConfig}
                walletConfig={walletConfig}
                timerCallback={timerCallback}
                setUpiDetails={setUpiDetails}
                isGPayIntentAvailable={isGPayIntentAvailable}
                paymentScreen={paymentScreen}
                showAllPaymentMethods={showAllPaymentMethods}
                newPaymentMethod={newPaymentMethod}
              />
            </SavedPaymentWrapper>
          )}

          {!PaymentOfferRevamp.experimentEnabled && (
            <PaymentOffers
              isVisible={flowConfig?.offers && paymentScreen === PAYMENT_SCREENS.SAVED}
              offersData={offersData}
              platform={platform}
              visibleOfferBottomSheet={visibleOfferBottomSheet}
              setVisibleOfferBottomSheet={setVisibleOfferBottomSheet}
              savedPaymentPage={true}
              isAutoScroll={true}
              showCarouselDots={true}
              setLoading={setLoading}
              isApp={isApp}
            />
          )}

          <MorePaymentMethod
            isVisible={
              areSavedPaymentMethodsDisplayed || isWalletDisplayed || isNewPaymentMethodVisible
            }
            setPaymentScreen={setPaymentScreen}
          />
          {flowConfig?.showPriceDetails && (
            <>
              {Boolean(Object.keys(cartInfo?.paymentDetails).length) && (
                <SectionTitleWrapper className="layout vertical mrl20 payment-view">
                  <Text
                    htmlText={OrderInformation}
                    font={theme.typography.sectionTitle}
                    color={theme.primaryText}
                    theme={theme}
                  />
                </SectionTitleWrapper>
              )}
              {flowConfig?.edd && EddPosition2?.switchEnabled && (
                <DeliveryEstimate {...eddConfig} platform={platform} />
              )}
              <NewPaymentDetails
                orderAmount={orderAmount}
                priceDetailConfig={priceDetailConfig}
                proceedToPayVisible={proceedToPayVisible}
                showBottomMargin={flowConfig?.edd && EddPosition2?.switchEnabled}
              />
            </>
          )}
          {flowConfig?.edd && (
            <>
              <DeliveryToast
                isToastVisible={isDeliveryEstimateToastVisible}
                toastDeliveryMessage={toastDeliveryMessage}
                setIsCheckButtonClickedOnToast={setIsCheckButtonClickedOnToast}
                setIsScrollToEddElement={setIsScrollToEddElement}
                setIsToastVisible={setIsDeliveryEstimateToastVisible}
              />
              {!EddPosition2?.switchEnabled && (
                <DeliveryEstimate {...eddConfig} platform={platform} />
              )}
            </>
          )}
          <BuyerAssuranceWrapper>
            <BuyerAssurance
              text={getStringFromId(
                VERNACULAR_STRING_IDS.BUYER_ASSURANCE,
                VERNACULAR_DEFAULT_MESSAGES.BUYER_ASSURANCE
              )}
              icon={getIcons(platform, ICONS_NAMES.BUYERS_ASSURANCE_ICON)}
              theme={theme}
              className="buyer-assurance"
            />
          </BuyerAssuranceWrapper>
        </>
      )}
    </div>
  );
};
